<template>
  <div class="lbt_box" v-if="imgfalgs">
    <img
      class="lbt_img"
      :src="imgs[0].url"
      alt=""
      v-show="num == 0 || num == 1"
    />
    <img
      class="lbt_img"
      :src="imgs[1].url"
      alt=""
      v-show="num == 1 || num == 2"
    />
    <img
      class="lbt_img"
      :src="imgs[2].url"
      alt=""
      v-show="num == 2 || num == 3"
    />
    <img class="lbt_img" :src="imgs[3].url" alt="" v-show="num == 3" />

    <div class="gradual_1" v-if="num == 0">
      <img class="lb_a1" src="../static/home/lb_a1.png" alt="" />
      <img class="lb_a2" src="../static/home/lb_a2.png" alt="" />
    </div>

    <div class="gradual_2" v-if="num == 1">
      <img class="lb_b1" src="../static/home/lb_b1.png" alt="" />
      <img class="lb_b2" src="../static/home/lb_b2.png" alt="" />
      <img class="lb_b3" src="../static/home/lb_b3.png" alt="" />
      <img class="lb_b4" src="../static/home/lb_b4.png" alt="" />
    </div>

    <div class="gradual_3" v-if="num == 2">
      <img class="lb_c1" src="../static/home/lb_c1.png" alt="" />
      <img class="lb_c2" src="../static/home/lb_c2.png" alt="" />
      <img class="lb_c3" src="../static/home/lb_c3.png" alt="" />
      <img class="lb_c4" src="../static/home/lb_c4.png" alt="" />
    </div>

    <div class="gradual_4" v-if="num == 3">
      <img class="lb_d1" src="../static/home/lb_d1.png" alt="" />
      <img class="lb_d2" src="../static/home/lb_d2.png" alt="" />
      <img class="lb_d3" src="../static/home/lb_d3.png" alt="" />
      <img class="lb_d4" src="../static/home/lb_d4.png" alt="" />
    </div>
  </div>
</template>

<script>
import { bannerList } from "@/api/article";
export default {
  data() {
    return {
      tirm: null, //定时器
      num: 0, //第几个

      imgs: [],
      imgfalgs: false,
    };
  },
  created() {
    this.Rotation();
    bannerList()
      .then((res) => {
        this.imgs = res.rows;
        this.imgfalgs = true; //请求成功
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    Rotation() {
      var that = this;
      this.tirm = setInterval(function () {
        if (that.num < 3) {
          that.num++;
        } else {
          that.num = 0;
        }
      }, 9000);
    },
  },

  beforeDestroy() {
    //退出页面时间
    clearInterval(this.tirm);
    this.tirm = null;
  },
};
</script>

<style scoped lang="less">
//
.lbt_box {
  width: 100%;
  height: 100%;
  position: relative;
}
.lbt_img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: 1s all;
  object-fit: cover;
  background-repeat: no-repeat;
  animation: bgimg 12s;
  animation-fill-mode: forwards;
}
@keyframes bgimg {
  0% {
    transform: scale(1.2);
    opacity: 1;
  }
  25% {
    transform: scale(1);
    opacity: 1;
    z-index: 2;
  }
  75% {
    transform: scale(1);
    opacity: 1;
    z-index: 3;
  }
  100% {
    transform: scale(1.2);
    opacity: 0;
    z-index: 3;
  }
}
//
.gradual_1 {
  width: 585px;
  height: 163px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
}
.lb_a1 {
  width: 585px;
  height: 105px;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  animation: lb1img 2s;
  animation-fill-mode: forwards;
}
@keyframes lb1img {
  0% {
    transform: scale(1.2);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.lb_a2 {
  width: 419px;
  height: 61px;
  position: absolute;
  top: 103px;
  left: 14px;
  opacity: 0;
  animation: textdh 2s;
  animation-fill-mode: forwards;
  animation-delay: 2s;
}
@keyframes textdh {
  0% {
    transform: translateX(-50%);
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.gradual_2 {
  width: 540px;
  height: 194px;
  position: absolute;
  top: 50%;
  left: 239px;
  transform: translateY(-50%);
  z-index: 5;
}
.lb_b1 {
  width: 537px;
  height: 116px;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  animation: lb1img 2s;
  animation-fill-mode: forwards;
}
.lb_b2 {
  width: 88px;
  height: 16px;
  position: absolute;
  top: 21px;
  left: 125px;
  opacity: 0;
  animation: lb1img 2s;
  animation-fill-mode: forwards;
  animation-delay: 2s;
}
.lb_b3 {
  width: 125px;
  height: 15px;
  position: absolute;
  top: 97px;
  left: 342px;
  opacity: 0;
  animation: lb1img 2s;
  animation-fill-mode: forwards;
  animation-delay: 2s;
}
.lb_b4 {
  width: 504px;
  height: 60px;
  position: absolute;
  top: 133px;
  left: 13px;
  opacity: 0;
  animation: textdh 2s;
  animation-fill-mode: forwards;
  animation-delay: 3s;
}

.gradual_3 {
  height: 270px;
  width: 447px;
  position: absolute;
  top: 50%;
  left: 242px;
  transform: translateY(-50%);
  z-index: 5;
}
.lb_c1 {
  width: 434px;
  height: 111px;
  position: absolute;
  top: 0;
  left: 10px;
  opacity: 0;
  animation: lb1img 2s;
  animation-fill-mode: forwards;
}
.lb_c2 {
  width: 88px;
  height: 16px;
  position: absolute;
  top: 71px;
  left: 8px;
  opacity: 0;
  animation: lb1img 2s;
  animation-fill-mode: forwards;
  animation-delay: 2s;
}
.lb_c3 {
  width: 102px;
  height: 14px;
  position: absolute;
  top: 12px;
  left: 121px;
  opacity: 0;
  animation: lb1img 2s;
  animation-fill-mode: forwards;
  animation-delay: 2s;
}
.lb_c4 {
  width: 445px;
  height: 131px;
  position: absolute;
  top: 136px;
  left: 0;
  opacity: 0;
  animation: textdh 2s;
  animation-fill-mode: forwards;
  animation-delay: 3s;
}

.gradual_4 {
  height: 307px;
  width: 422px;
  position: absolute;
  top: 50%;
  left: 239px;
  transform: translateY(-50%);
  z-index: 5;
}
.lb_d1 {
  width: 423px;
  height: 226px;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  animation: lb1img 2s;
  animation-fill-mode: forwards;
}
.lb_d2 {
  width: 192px;
  height: 14px;
  position: absolute;
  top: 0;
  left: 121px;
  opacity: 0;
  animation: lb1img 2s;
  animation-fill-mode: forwards;
  animation-delay: 2s;
}
.lb_d3 {
  width: 135px;
  height: 14px;
  position: absolute;
  top: 111px;
  left: 160px;
  opacity: 0;
  animation: lb1img 2s;
  animation-fill-mode: forwards;
  animation-delay: 2s;
}
.lb_d4 {
  width: 313px;
  height: 61px;
  position: absolute;
  top: 246px;
  left: 0;
  opacity: 0;
  animation: textdh 2s;
  animation-fill-mode: forwards;
  animation-delay: 3s;
}
</style>
